<template>
  <div class="story-content">
    <template v-for="(part, idx) in story.descriptionParts">
      <AppStoryCarousel
        v-if="part.slides && part.slides.length"
        :key="`${story.id}_${part.__typename}_${idx}`"
        class="slides"
        :slides="part.slides"
        :unique-id="story.id"
      />
      <AppRelatedSmallSection
        v-else-if="part.relatedRecords && part.relatedRecords.length"
        :key="`${story.id}_${part.__typename}_${idx}`"
        class="story-content-part"
        :items="part.relatedRecords"
      />
      <StoryDescriptionTextPart v-else :key="`${story.id}_${part.__typename}_${idx}`" :text="part.text" />
    </template>
  </div>
</template>

<script>
import AppRelatedSmallSection from '@/components/partials/AppRelatedSmallSection';
import AppStoryCarousel from '@/components/partials/AppStoryCarousel.vue';
import StoryDescriptionTextPart from '@/components/partials/StoryDescriptionTextPart';

export default {
  name: 'StoryDefaultTemplate',
  components: { AppStoryCarousel, AppRelatedSmallSection, StorySlides: AppStoryCarousel, StoryDescriptionTextPart },
  props: {
    story: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.story-content {
  .slides {
    margin: 50px 0 50px 16px;

    @media (min-width: vars.$tablet-break-point) {
      margin: 75px 0;
    }
  }
}
</style>
